import React from "react";

import { Observation } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useQueryPagination } from "@/hooks/use-pagination";
import { useRouterTableData } from "@/hooks/use-router-table-data";
import { DeleteGldObservationButton, addDeleteButton } from "@/libs/delete-button";
import { useGldObservationListQuery } from "@/queries/query-gld-observation";

export const gldObservationInformation: { key: keyof Observation; label: string }[] = [
  { key: "observationType", label: "Reeks type" },
  { key: "validationStatus", label: "Validatie status" },
  { key: "beginPosition", label: "Start tijd" },
  { key: "endPosition", label: "Eind tijd" },
  { key: "measurementInstrumentType", label: "Meetinstrument" },
];

const columnDefinitions: ColumnDefinition<Observation>[] = addDeleteButton(
  gldObservationInformation.map(({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/gld/aanvulling/${row.uuid}/` : undefined),
    width: "1fr",
  })),
  DeleteGldObservationButton
);

const GldObservationTable: React.FC<{ gld: string }> = ({ gld }) => {
  const { page, setPage } = useRouterTableData({ hasSearchParams: false });
  const { data: gldObservationsList, isLoading } = useGldObservationListQuery({ gld, page });
  const paginationProps = useQueryPagination({
    queryResponse: gldObservationsList,
    page,
    setPage,
  });

  if (gldObservationsList != null) {
    gldObservationsList.results.sort((a, b) => {
      // If both dates are undefined or null, they are equal
      if (!a.beginPosition && !b.beginPosition) return 0;

      // If a's date is undefined or null, b should come first
      if (!a.beginPosition) return 1;

      // If b's date is undefined or null, a should come first
      if (!b.beginPosition) return -1;

      // Compare the timestamps for sorting
      return a.beginPosition.getTime() - b.beginPosition.getTime();
    });
  }
  return (
    <TableOverview
      themeColor="#b9acfc"
      isLoading={isLoading}
      tableData={gldObservationsList?.results ?? []}
      columnDefinitions={columnDefinitions}
      paginationProps={paginationProps}
    />
  );
};

export { GldObservationTable };
